// extracted by mini-css-extract-plugin
export var blockedMessage = "_80-3";
export var blockedOverlay = "_80-1";
export var fadeIn = "_80-2";
export var hereLink = "_80-0";
export var slideUp = "_80-4";